<template>
  <div class="searchTargerts">
    <v-radio-group
      v-model="target"
      label="Source"
      class="pr-2 mr-4"
    >
      <v-radio
        v-for="option in radioOptions"
        v-bind:key="option.name"
        :label="option.value"
        :value="option.value"
        :color="option.color"
        :disabled="option.disabled && !getPermission"
      />
    </v-radio-group>

    <component v-bind:is="currentOption"></component>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import OptionsWallheaven from './OptionsWallheaven.vue'

export default {
  name: 'SearchTargets',

  data: () => {
    return {
      target: '',

      radioOptions: [
        {
          name: 'wallheaven',
          value: 'wallheaven',
          color: 'red',
          component: OptionsWallheaven
        },
        {
          name: 'safebooru',
          value: 'safebooru',
          color: 'blue'
        },
        {
          name: 'yande.re',
          value: 'yande.re',
          color: 'orange'
        },
        {
          name: 'danbooru',
          value: 'danbooru',
          color: 'green',
          disabled: true
        },
        {
          name: 'civitai',
          value: 'civitai',
          color: 'yellow',
          disabled: true
        }
      ]
    }
  },

  watch: {
    target() {
      this.$emit('targetChose', this.target)
    }
  },

  computed: {
    ...mapState('options', ['options']),
    ...mapGetters('admin', ['getPermission']),

    currentOption: function () {
      return this.radioOptions.find((option) => option.name === this.target).component
    }
  },

  created() {
    this.target = this.options.target
  }
}
</script>

<style
  scoped
  lang="scss"
>
.searchTargerts {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>
